import { mode } from '@chakra-ui/theme-tools';

function baseStyle(props) {
  var hoverBorder = mode('brand.500', 'whiteAlpha.100')(props);
  var activeBg = mode('brand.500', 'whiteAlpha.200')(props);
  return {
    transition: 'all 0.2s',
    color: 'brand.500',
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
      boxShadow: 'none'
    },
    _hover: {
      bg: 'transparent'
    },
    _active: {
      bg: 'transparent'
    },
    _focus: {
      boxShadow: 'none'
    }
  };
}

var sizes = {
  lg: {
    w: '40px',
    h: '40px',
    fontSize: '16px',
    borderRadius: 'base'
  },
  md: {
    w: '32px',
    h: '32px',
    fontSize: '12px',
    borderRadius: 'base'
  },
  sm: {
    w: '22px',
    h: '22px',
    fontSize: '10px',
    borderRadius: 'md'
  }
};
var defaultProps = {
  size: 'md'
};
export default {
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=CloseButton.js.map